import { RouteItem } from '@eastcoal/router/types/route'

import { PRICE_COMPARE_DETAIL_PAGE_PATH } from './constants/path'

export const priceCompareDetailRoute: RouteItem = {
  title: '场次详情',
  path: PRICE_COMPARE_DETAIL_PAGE_PATH,
  hideInMenu: true,
  Component: () => import('./index')
}
